<div class="container {{ OBJ_LNG_NAME }} insertEdit">
  <div class="dialog-header">
    <h1 mat-dialog-title>
      {{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
      <mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
    </h1>
    <button class="close-button" mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
  </div>
  <mat-dialog-content>
    <form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">

      <p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

      <mat-form-field class="full-width">
        <input matInput #sprachschluessel="ngModel" [(ngModel)]="aktuell.tempSprachSchluessel" type="text" name="sprachschluessel"
               maxlength="248" [disabled]="dialogrunningajaxcall" pattern="[a-z.]+" required />
<mat-label>{{ OBJ_LNG_NAME+'.sprachschluessel' | translate:locale.language }}</mat-label>
        <span matPrefix>kerngruppe.</span>
        <mat-hint *ngIf="sprachschluessel.errors && (sprachschluessel.dirty || sprachschluessel.touched) && sprachschluessel.errors.pattern">{{ 'allgemein.validierung.nichtsprachschlüssel' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.sprachschluessel' | translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="sprachschluessel.errors && (sprachschluessel.dirty || sprachschluessel.touched) && sprachschluessel.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.sprachschluessel' | translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="sprachschluessel.value" align="end">{{ sprachschluessel.value.length + 7 }} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width"  *ngIf="aktuell.rechte != null && aktuell.rechte.length > 0">
        <mat-select multiple="true" [compareWith]="compareMitId" [(ngModel)]="aktuell.kernRechte" name="rechteCtl"
                    [formControl]="aktuell.selectCtl"
                    placeholder="{{ 'allgemein.auswählen' | translate:locale.language:{ typ: 'kernrecht.typen' | translate:locale.language } }}">
			<mat-option>
          		<ngx-mat-select-search name="filter" [formControl]="aktuell.filterCtl"></ngx-mat-select-search>
			</mat-option>
          <mat-option *ngFor="let i of aktuell.filtered | dataPipeKernrecht:aktuell.filterCtl" [value]="i">{{i.sprachschluessel}}</mat-option>
        </mat-select>
		  <mat-label>{{ 'kernrecht.typ' | translate:locale.language }}</mat-label>
      </mat-form-field>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{ 'allgemein.abbrechen' | translate:locale.language }}</button>
    <button mat-raised-button type="submit" (click)="speichernAendern()" color="primary" [disabled]="!inserteditForm.form.valid || dialogrunningajaxcall">
      <mat-spinner *ngIf="dialogrunningajaxcall"></mat-spinner>
      {{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
    </button>

  </mat-dialog-actions>
</div>

